<template>
  <div>
    <el-table-column label="倍数" width="100px">
      <template v-slot:default="scope">
        <el-input v-model.number="scope.row.bet" placeholder="倍数" />
      </template>
    </el-table-column>
    <el-table-column label="类型">
      <template v-slot:default="scope">
        <el-select v-model.number="scope.row.mtype" placeholder="请选择" @change="buyChange(scope.row)">
          <el-option v-for="(item, index) in buyType" :key="index" :disabled="limitType.length >0 && !limitType.includes(item.value)" :label="item.label" :value="item.value" />
        </el-select>
      </template>
    </el-table-column>
    <el-table-column label="价格">
      <template v-slot:default="scope">
        <el-select v-if="scope.row.mtype === 2" v-model.number="scope.row.price" placeholder="请选择" @change="priceChange(scope.row)">
          <el-option v-for="(item, index) in shopSku" :key="index" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-if="scope.row.mtype === 1" v-model="scope.row.coin" placeholder="请选择" @change="mtTypeChange(scope.row)">
          <el-option v-for="(item, index) in coinType" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </template>
    </el-table-column>
    <el-table-column label="SKU" width="260px">
      <template v-slot:default="scope">
        <el-input v-model="scope.row.sku" readonly placeholder="库存" />
      </template>
    </el-table-column>
  </div>
</template>

<script>

import { getSku } from '@/api/config/shop-cfg'

export default {
  name: 'Price',
  props: {
    limitType: {
      type: Array,
      default: () => []
    },
    canFree: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      buyType: [
        { 'value': 1, 'label': '金币' },
        { 'value': 2, 'label': '付费' },
        { 'value': 3, 'label': '钻石' },
        { 'value': 4, 'label': '广告' }
      ],
      coinType: [
        { label: 'money1', value: 'money1' },
        { label: 'money2', value: 'money2' },
        { label: 'money3', value: 'money3' },
        { label: 'money4', value: 'money4' },
        { label: 'money5', value: 'money5' },
        { label: 'money6', value: 'money6' }
      ],
      shopSku: [

      ]
    }
  },
  watch: {
    value: function(newVal) {
      this.$emit('input', newVal)
    }
  },
  created() {
    this.getSkuList()
  },
  methods: {
    getSkuList() {
      this.getCacheConfig(getSku, 'getSkuList', { type: 3 }).then(res => {
        if (this.canFree) {
          this.shopSku = [{ label: '免费', value: 0, sku: '' }]
        }
        res.data.forEach((item) => {
          this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
        })
      })
    },
    buyChange(v) {
      if (v.mtype === 1) {
        v.sku = ''
        v.coin = this.coinType[0].value
      } else if (v.mtype === 2) {
        v.sku = this.shopSku[0].sku
        v.price = this.shopSku[0].value
      } else {
        v.sku = ''
        v.price = 0
      }
    },
    priceChange(v) {
      for (let i = 0; i < this.shopSku.length; i++) {
        if (this.shopSku[i].value === v.price) {
          v.sku = this.shopSku[i].sku
        }
      }
    },
    mtTypeChange(v) {
      v.sku = ''
    },
    getCacheConfig(func, name = '', params = {}) {
      const funcName = name
      const data = localStorage.getItem(funcName)
      if (data) {
        return new Promise((resolve, reject) => {
          resolve(JSON.parse(data))
        })
      } else {
        return func(params).then(item => {
          localStorage.setItem(funcName, JSON.stringify(item))
          return item
        })
      }
    }
  }
}
</script>
